<template>
  <div class="template-message conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-collapse-transition>
        <div class="search-content common-search-formtype" style="line-height: 60px">
          <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
            公众号切换：
            <el-select v-model="original_id" placeholder="请选择" @change='publicNumberChange'>
              <el-option
                v-for="item in publicNumber"
                :key="item.original_id"
                :label="item.nick_name"
                :value="item.original_id">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button v-if="butsObj.sync" type="primary" class="add-btn btn-right" style="float: right;margin-left: 0" @click="messageUpdate">同步模板</el-button>
        <el-button v-if="butsObj.add" type="primary" class="add-btn list-btn-margin" style="float: right;" @click='TipsTemplate'>添加模板消息</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        class="table"
        v-loading="loading"
        :data="tableData">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="TipsTemplate">新建</span></div>
        </template>
        <el-table-column
          prop="message_title"
          label="模板消息名称">
        </el-table-column>
        <el-table-column
          prop="title"
          label="模板名称">
        </el-table-column>
        <el-table-column
          prop="tmpContent"
          label="内容">
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{ scope.row.tmpContent?scope.row.tmpContent:'——' }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="name"
          label="预览">
        </el-table-column> -->
        <el-table-column
          width="150"
          label="创建时间">
          <template slot-scope="scope">
            {{scope.row.create_time.substring(0, 16)}}
          </template>
        </el-table-column>
        <el-table-column
          label="群发记录">
          <template slot-scope="scope">
            <!--
            <div class="op-link" @click='groupRecordDetail(scope.row.send_list)'>
              <span>已群发{{scope.row.send_number}}次</span>
            </div>
            -->
            <div>
              <span>已群发{{scope.row.send_number}}次</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="170"
          label="操作">
          <template slot-scope="scope">
            <div v-if="butsObj.group_send" class="op-link" @click='groupMessages(scope.row.id)'>
              群发
            </div>
            <!-- <el-tooltip class="item" effect="dark" content="复制" placement="bottom">
              <div class="op-link" @click="messageCopy(scope.row.id)">
                <i class="iconfont icon-fuzhi" style="font-size: 14px"></i>
              </div>
            </el-tooltip> -->
            <router-link v-if="butsObj.edit" :to="{ path: '/home/template-message-add' , query: { id: scope.row.id}}">
              <div class="op-link editColor">
                编辑
              </div>
            </router-link>
            <div v-if="butsObj.del" class="op-link deleteColor" @click='messageDelete(scope.row.id)'>
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot" style="text-align: right">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!-- 新建模板消息 -->
    <el-dialog
      class="cellDialog"
      title="新建模版消息"
      :visible.sync="addTemplate"
      width="500px">
      <!-- <el-tabs :tab-position="tabPosition" style="height: 270px;" type="border-card" v-model="templateId">
        <el-tab-pane :label="item.title" v-for="item in Template" :key='item.id' :name="item.template_id">
          {{item.title}}
          <p>{{item.example}}</p>
        </el-tab-pane>
      </el-tabs> -->
      <div class="template-content">
        <div class="template-left">
          <div class="template-list-item" v-for="(item, index) in Template" :key="item.id" @click="selectItem(item, index)" :class="{'selectedClass': item.isSelected }">
            {{ item.title }}
          </div>
        </div>
        <div class="template-right">
          <p class="template-title">{{ templateItem.title }}</p>
          <p class="template-example">{{ templateItem.example }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="addTemplate = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="addTemplateTrue">创 建</el-button>
      </span>
    </el-dialog>
    <!-- 群发记录 -->
    <el-dialog
      class="cellDialog"
      title="群发记录"
      :visible.sync="groupRecord"
      width="800px">
      <el-table
        border
        :data="groupRecordData"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="发送群组">
        </el-table-column>
        <el-table-column
          prop="send_time"
          label="发送时间">
        </el-table-column>
        <el-table-column
          prop="send_number"
          label="发送人数">
        </el-table-column>
        <el-table-column
          prop="sunccess_num"
          label="发送成功数">
        </el-table-column>
        <el-table-column
          prop="success_percent"
          label="发送成功率">
        </el-table-column>
        <el-table-column
          label="发送状态或操作">
          <template slot-scope="scope">
            <div class="op-link" @click='downDetail(scope.row.id)'>
              <span>下载明细</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="groupRecord = false">取 消</el-button>
        <el-button style="margin-right: 20px" class="dialog-confirm-btn" type="primary" @click="groupRecord = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 群发消息 -->
    <el-dialog
      class="cellDialog base-dialog"
      title="群发消息"
      :visible.sync="groupHair"
      width="520px">
      <span>客户群组：</span>
      <el-select v-model="customerGroupId" filterable placeholder="请选择">
        <el-option
          v-for="item in customerGroup"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="groupMessagesFalse">取 消</el-button>
        <el-button style="margin-right: 32px" class="dialog-confirm-btn" type="primary" @click="groupMessagesTrue">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { messageList, templatesApi, messageAdd, messageDelete, customerGroupApi, messageSend, messageUpdate, messageCopy, download } from '@/api/customer.js'
import { getAudGroupList } from '@/api/set.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'templateMessage',
  data () {
    return {
      modelId: '',
      myStroage: window.localStorage,
      loading: true,
      templateItem: {},
      tableData: [],
      Template: [],
      templateId: null, // 新建模板消息的id
      original_id: '',
      publicNumber: [],
      customerGroupId: '',
      customerGroup: [], // 客户群族
      groupMessagesId: '', // 群发消息的id
      addTemplate: false, // 添加模板消息弹窗
      tabPosition: 'left',
      groupRecord: false, // 群发记录
      groupRecordData: [],
      groupHair: false, // 群发
      AddTips: false, // 没有模板时提示弹窗
      total: 0,
      page: 1,
      limit: 10,
      butsObj: { // button按钮列表
        add: false,
        sync: false,
        group_send: false,
        edit: false,
        del: false
      }
    }
  },
  mounted () {
    rule.publicNumber((res) => {
      for (let item of res.data.data.list) {
        if (item.is_disable === 0) {
          this.publicNumber.push(item)
          if (item.is_default === 1) {
            this.public_id = item.id
            this.modelId = item.model_id
            // if (this.myStroage.getItem('templateMessage', this.original_id)) {
            //   this.original_id = this.myStroage.getItem('templateMessage', this.original_id)
            // } else {
            // }
            this.original_id = item.original_id
          }
        }
      }
      this.customerGroupApi()
      this.getButtonsList()
    })
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    publicNumberChange(val) {
      for (let one of this.publicNumber) {
        if (one.original_id === val) {
          this.modelId = one.model_id
        }
      }
      this.myStroage.setItem('templateMessage', this.original_id)
      this.getData()
      this.customerGroupApi()
    },
    selectItem(it, index) {
      this.templateItem = it
      this.templateId = it.template_id
      for (let one of this.Template) {
        one.isSelected = false
      }
      this.Template[index].isSelected = true
    },
    getData() {
      this.loading = true
      this.templatesApi()
      let data = {
        original_id: this.original_id,
        page: this.page,
        limit: this.limit
      }
      messageList(data).then((res) => {
        if (res.data.code === 0) {
          let tableDataArray = res.data.data.list
          // this.page = res.data.data.page.current_page
          this.total = res.data.data.total
          for (let one of tableDataArray) {
            one.tmpContent = ''
            let oneStr = ''
            let tmpStr = JSON.parse(one.content)
            for (let two of this.Template) {
              if (one.template_id === two.template_id) {
                oneStr = two.content.replace('{{first.DATA}}', tmpStr.first)
                oneStr = oneStr.replace('{{orderno.DATA}}', tmpStr.orderno)
                oneStr = oneStr.replace('{{refundno.DATA}}', tmpStr.refundno)
                oneStr = oneStr.replace('{{refundproduct.DATA}}', tmpStr.refundproduct)
                oneStr = oneStr.replace('{{remark.DATA}}', tmpStr.remark)
                oneStr = oneStr.replace('{{content.DATA}}', tmpStr.content)
                oneStr = oneStr.replace('{{keyword1.DATA}}', tmpStr.keyword1)
                oneStr = oneStr.replace('{{keyword2.DATA}}', tmpStr.keyword2)
                oneStr = oneStr.replace('{{keyword3.DATA}}', tmpStr.keyword3)
                oneStr = oneStr.replace('{{keyword4.DATA}}', tmpStr.keyword4)
                oneStr = oneStr.replace('{{keyword5.DATA}}', tmpStr.keyword5)
              }
            }
            one.tmpContent = oneStr
          }
          this.tableData = tableDataArray
          this.customerGroupId = ''
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 群发记录
    groupRecordDetail(list) {
      this.groupRecord = true
      this.groupRecordData = list
    },
    // 客户群组
    customerGroupApi() {
      getAudGroupList(this.modelId, 1, 10000, '', '').then((res) => {
        if (res.data.code == 200) {
          this.customerGroup = res.data.result.list
          console.log(res.data)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 群发消息
    groupMessages(id) {
      this.groupHair = true
      this.groupMessagesId = id
    },
    groupMessagesFalse() {
      this.groupHair = false
      this.customerGroupId = ''
    },
    groupMessagesTrue() {
      let data = {
        id: this.groupMessagesId,
        customer_group: this.customerGroupId
      }
      messageSend(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data)
          this.groupHair = false
          this.getData()
          _g.toastMsg('success', '发送成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 模板列表
    templatesApi() {
      let data = {
        original_id: this.original_id
      }
      templatesApi(data).then((res) => {
        if (res.data.code === 0) {
          if (res.data.data.list.length > 0) {
            this.Template = []
            for (let it of res.data.data.list) {
              this.Template.push({
                'template_id': it.template_id,
                'content': it.content,
                'title': it.title,
                'example': it.example,
                'isSelected': false
              })
            }
            this.Template[0].isSelected = true
            this.templateId = res.data.data.list[0].template_id
            this.templateItem = this.Template[0]
            this.AddTips = false
          } else {
            this.templateId = ''
            this.AddTips = true
          }
          // this.templateAddId = res.data.data.list[0].template_id
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加模板消息提示
    TipsTemplate() {
      if (this.AddTips) {
        this.$alert('<p>抱歉，您还没有可使用的消息模板</p><p>您可以前往<a href="https://mp.weixin.qq.com/">微信后台</a>添加模板</p>', '提示', {
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          showConfirmButton: false
          // confirmButtonText: '取消'
        })
      } else {
        this.addTemplate = true
      }
    },
    // 添加
    addTemplateTrue() {
      messageAdd(this.templateId).then((res) => {
        if (res.data.code === 0) {
          // this.addTemplate = false
          this.$router.push({path: '/home/template-message-add', query: { original_id: this.original_id, template_id: this.templateId, contentArr: res.data.data.contentArr }})
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    //  删除
    messageDelete(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          id: id
        }
        messageDelete(data).then((res) => {
          console.log(res)
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除成功')
            this.getData()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 同步模板消息
    messageUpdate() {
      let data = {
        original_id: this.original_id
      }
      messageUpdate(data).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 复制模板消息
    messageCopy(id) {
      let data = {
        id: id
      }
      messageCopy(data).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '复制成功')
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 群发记录--下载明细
    downDetail(id) {
      let data = {
        id: id
      }
      download(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data.data.url)
          var url = res.data.data.url
          // window.open(url)
          // var blob = new Blob([url], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement('a')
          // var href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = url
          downloadElement.download = url + '.xlsx' // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 处理分页
    handleCurrentChange(val) {
      this.page = val
      this.getData()
    },
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style scoped>
  /deep/.el-table .cell div:empty::before{
    content:'——';
    color:gray;
  }
  .sign-manage-title {
    background: #ecf6ff;
    border: 1px solid #E4e4e4;
    height:60px;
    padding:10px;
    line-height: 40px;
    margin-top: 10px;
  }
  .green{
    color: green;
  }
  .red{
    color: red;
  }
  .table-title {
    text-align: left;
  }
  .dialog-content {
    height: 200px;
  }
  .content-one span {
    display: inline-block;
    float: left;
    line-height: 20px;
    font-size: 16px;
    margin-top: 10px;
  }
  .content-one p {
    text-align: left;
  }
  .search-flod-content{
    border: none;
  }
  .template-content {
    width: 100%;
    height: 270px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .template-left {
    height: 320px;
    width: 38%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .template-right {
    height: 280px;
    width: 55%;
    border: 1px solid #E7E7E7;
    border-radius: 8px;
    padding: 10px;
  }
  .template-list-item {
    height: 40px;
    width: 96%;
    border: 1px solid #E7E7E7;
    margin-bottom: 10px;
    line-height: 40px;
    border-radius: 6px;
    color: #999;
  }
  .template-title {
    text-align: left;
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin-top: 0px;
    padding: 0 10px;
  }
  .template-example {
    text-align: left;
    padding: 0 10px;
  }
  .selectedClass {
    border: 1px solid #1980FF;
    color: #333;
    font-family: PingFangSC;
    background: url('../../assets/images/bingo.jpg') no-repeat right top;
  }
</style>
